import type { NavigationState, PartialState } from '@react-navigation/native';
import { Platform } from 'react-native';
import { getActiveRouteName, getActiveRoutePath } from './getActiveRouteName';
import { getScreenFileForRoute } from './screenFileMap';

export type ReportedRoute = {
  name: string | null;
  path: string;
  file: string | null;
};

type Listener = (info: ReportedRoute) => void;

type NavState = NavigationState | PartialState<NavigationState> | undefined;

let current: ReportedRoute = { name: null, path: '', file: null };
const listeners = new Set<Listener>();

function syncGlobals(info: ReportedRoute) {
  const payload = { ...info, updatedAt: Date.now() };
  try {
    // eslint-disable-next-line no-undef
    (globalThis as any).__SMARTSAAS_NAV__ = payload;
  } catch {
    // ignore
  }
  if (Platform.OS === 'web' && typeof window !== 'undefined') {
    (window as any).__SMARTSAAS_NAV__ = payload;
  }
}

export function getReportedRoute(): ReportedRoute {
  return current;
}

export function publishNavigationState(state: NavState): ReportedRoute {
  const name = getActiveRouteName(state);
  const path = getActiveRoutePath(state);
  const file = getScreenFileForRoute(name);
  current = { name, path, file };
  syncGlobals(current);
  listeners.forEach((listener) => {
    try {
      listener(current);
    } catch {
      // ignore subscriber errors
    }
  });
  return current;
}

export function subscribeNavigationRoute(listener: Listener): () => void {
  listeners.add(listener);
  listener(current);
  return () => {
    listeners.delete(listener);
  };
}
